// BatSeqDetailCache.js
//
// Sequence steps per rk, ref = master rk.
import CacheBase2 from '../../../services/engines/CacheBase2';

const _name = 'BatSeqDetailCache';

class BatSeqDetailCache extends CacheBase2 {
    _name = _name;

    /**
     * Steps of one master, sorted by order.
     * @param {string} ref - master rk
     * @returns {object[]}
     */
    byRef = (ref) => {
        const items = this.getAll().filter((d) => d.ref === ref);
        return items.sort((a, b) => a.order - b.order);
    };
}

const batSeqDetailCache = new BatSeqDetailCache();
export default batSeqDetailCache;
